export const ru = 'ru';
export const en = 'en';
export const defaultFormsLocale = ru;
